import get from 'lodash/get';

import { CMD_ARG_TYPE } from '@/constants/iqtool';
import { allCommandsBySystemName } from '@/libs';

export default {
  name: 'aiqCommandView',
  props: {
    // command object
    command: {
      type: Object,
    },
    // lookup table to find name of function in the command
    lookup: {
      type: Object,
    },
  },
  computed: {
    description() {
      return get(this.command, 'payload.description', '');
    },
    functions() {
      const functions = get(this.command, 'payload.functions', []);

      return functions.map(funcData => {
        if (!funcData.command_name) {
          return;
        }

        const args = [];
        let funcName = '';
        const funcDetailInfo = this.lookup?.functions?.find(row => row.commandName === funcData.command_name);
        const paramsType = allCommandsBySystemName[funcData.command_name]?.paramsType;
        const paramsList = allCommandsBySystemName[funcData.command_name]?.getParamsList(this.$store);
        const commandParams = allCommandsBySystemName[funcData.command_name]?.toComponentParams(funcData.params);

        if (funcDetailInfo) {
          funcName = funcDetailInfo.functionName;

          if (paramsType === CMD_ARG_TYPE.MULTI_SELECT) {
            if (Array.isArray(paramsList)
              && paramsList.length > 0
              && Array.isArray(commandParams)
              && commandParams.length > 0) {
              paramsList.forEach(param => {
                if (commandParams.includes(param.id)) {
                  args.push(param.name);
                }
              });
            }
          }
          else if (paramsType === CMD_ARG_TYPE.SINGLE_SELECT) {
            if (commandParams?.name) {
              args.push(commandParams.name);
            }
          }
          else if (paramsType === CMD_ARG_TYPE.BOOL_SELECT) {
            if (commandParams && paramsList[0]) {
              args.push(paramsList[0]);
            }
            else if (paramsList[1]) {
              args.push(paramsList[1]);
            }
          }
          else if (paramsType === CMD_ARG_TYPE.MULTI_KEYWORD) {
            if (Array.isArray(commandParams?.arguments) && commandParams?.arguments.length > 0) {
              commandParams?.arguments.forEach(arg => {
                args.push(arg);
              });
            }
          }
          else if (paramsType === CMD_ARG_TYPE.OBJ_CONSTRUCT) {
            if (Array.isArray(funcData?.params?.arguments) && funcData.params.arguments.length > 0) {
              funcData.params.arguments.forEach(arg => {
                const lValue = get(arg, 'left_val', '');
                const rValue = get(arg, 'right_val', '');
                args.push([lValue, rValue]);
              });
            }
          }
        }

        return {
          name: funcName,
          chips: args,
        };
      });
    },
  },
};
